<template>
  <layout-editor-page
    :title="formTitle"
    :isLoading="isLoading"
    :isVisible="isVisible"
    :isBack="hasCreateNew"
    :isCancel="!hasCreateNew"
    @command="setCommand"
  >
    <form-contacts
      :disabled="disabled"
      :data="data"
      :model="formModel"
      @change="handleFormData"
      @onAutoSave="mixAutoSave"
      ref="Form"/>
    <template v-slot:footer>
      <form-controls
        class="form-footer"
        :isCreate="!hasCreateNew && !disabled"
        :isSave="hasCreateNew && !disabled"
        :isClipboard="hasCreateNew"
        :isDelete="hasCreateNew && !disabled"
        @command="setCommand"
      />
    </template>
  </layout-editor-page>
</template>

<script>
import FormWrapper from '@/components/Form/FormWrapper'
import { AutoSaveMixin } from '@/mixins/FormAutoSave'
import { ModelRFQ2s, ServiceRFQ2s } from '@/services/RFQ2s'

export default {
  name: 'EditorRfq2List',
  mixins: [FormWrapper, AutoSaveMixin],
  components: {
    'form-contacts': () => import(/* webpackChunkName: 'Rfq2List' */ './Form'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  computed: {
    formTitle () {
      return this.formData.name || this.checkEs6AndRun(this.title)
    },
    apiAutoSave () {
      return `${ServiceRFQ2s.apiPatch}/${this.currentID}`
    },
    isAvailableToSave () {
      return this.hasCreateNew
    }
  },
  methods: {
    formModel () {
      return new ModelRFQ2s()
    }
  }
}
</script>
